module.exports = __webpack_public_path__ + "img/JM.c7c4f600.svg";